import styled from 'styled-components';

import { Container as oContainer, ContainerProps, Label as oLabel, Value as oValue } from '../BookingSelectDate/styles';

export const Container = styled(oContainer)<ContainerProps>`
  background: ${({ theme, $disabled }) =>
    $disabled ? theme.searchInput.time.disabled.background : theme.searchInput.time.background};
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.searchInput.time.disabled.label.color : theme.searchInput.time.label.color};
  border: ${({ theme, $disabled }) =>
    $disabled ? theme.searchInput.time.disabled.border : theme.searchInput.time.border};
  box-shadow: ${({ theme, $disabled }) =>
    $disabled ? theme.searchInput.time.disabled.boxShadow : theme.searchInput.time.boxShadow};

  height: ${({ theme }) => theme.searchInput.time.height};
  padding: ${({ theme }) => theme.searchInput.time.padding};
`;

export const Label = styled(oLabel)`
  top: ${({ theme }) => theme.searchInput.time.detail.top};

  font-size: ${({ theme }) => theme.searchInput.time.detail.fontSize};
  color: ${({ theme }) => theme.searchInput.time.detail.color};
`;

export const Value = styled(oValue)`
  font-size: ${({ theme }) => theme.searchInput.time.label.fontSize};
  color: ${({ theme, active }) =>
    active ? theme.searchInput.time.label.color : theme.searchInput.time.placeholder.label.color};
  margin-top: ${({ theme }) => theme.searchInput.time.label.marginTop};
`;
